import { render } from "./Transactions.vue?vue&type=template&id=77126b05"
import script from "./Transactions.vue?vue&type=script&setup=true&lang=js"
export * from "./Transactions.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Transactions.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "77126b05"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('77126b05', __exports__)) {
    api.reload('77126b05', __exports__)
  }
  
  module.hot.accept("./Transactions.vue?vue&type=template&id=77126b05", () => {
    api.rerender('77126b05', render)
  })

}


export default __exports__